const KEY = 'rv_theme';

export const getTheme = () => {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
};

export const applyTheme = (theme) => {
  const light = theme === 'light';
  document.documentElement.classList.toggle('theme-light', light);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', light ? '#F4ECDD' : '#1A1A1A');
  import('@capacitor/core').then(({ Capacitor }) => {
    if (!Capacitor.isNativePlatform()) return;
    import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
      StatusBar.setStyle({ style: light ? Style.Light : Style.Dark }).catch(() => {});
      StatusBar.setBackgroundColor?.({ color: light ? '#F4ECDD' : '#1A1A1A' }).catch(() => {});
    }).catch(() => {});
  });
};

export const setTheme = (theme) => {
  try { localStorage.setItem(KEY, theme); } catch { /* private mode */ }
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent('rv-theme', { detail: theme }));
};
